
import Vue from "vue";
import { Auth } from "aws-amplify";
import ButtonDefault from "@/components/atoms/ButtonDefault.vue";
import TextField from "@/components/molecules/TextField.vue";
import { showNotifyDialog } from "@/lib/dialog";

interface Data {
  message: string;
  newPassword: string;
  code: string;
}

interface Methods {
  submit(): Promise<void>;
}

interface Computed {
  from: string | undefined;
}

interface Props {
  username: string;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  // NOTE: metaタグの設定
  metaInfo: {
    meta: [
      {
        name: "robots",
        content: "none",
      },
    ],
  },
  components: { ButtonDefault, TextField },
  props: {
    username: String,
  },
  created() {
    if (this.from === "nolanovel") {
      document.title = this.$t('resetPasswordSubmitPage.pageTitle.nolaNovel') as string;
    } else if (this.from === "default") {
      document.title = this.$t('resetPasswordSubmitPage.pageTitle.default') as string;
    }
  },
  data() {
    return {
      message: "",
      newPassword: "",
      code: "",
    };
  },
  computed: {
    from() {
      return this.$route.query.from;
    },
  },
  methods: {
    async submit() {
      const { username, code, newPassword: password } = this;

      try {
        const res = await Auth.forgotPasswordSubmit(username, code, password);
        console.log(res);

        await showNotifyDialog({
          content:
            this.from === "default"
              ? this.$t('resetPasswordSubmitPage.successMessage.default')
              : this.$t('resetPasswordSubmitPage.successMessage.normal'),
        });
        if (this.from === "default") {
          window.location.href = "https://indent.co.jp/#product";
        } else if (this.from === "nolanovel") {
          window.location.href = `${process.env.VUE_APP_NOLANOVEL_WEB}/auth`;
        } else {
          this.$router.push({ name: "signIn" });
        }
      } catch (error) {
        if (error.code === "CodeMismatchException") {
          this.message = this.$t('resetPasswordSubmitPage.validation.codeMismatch') as string;
        } else if (error.code === "UsernameExistsException") {
          this.message = this.$t('resetPasswordSubmitPage.validation.emailAlreadyExists') as string;
        } else if (error.code === "InvalidParameterException" || error.code === "InvalidPasswordException") {
          this.message = this.$t('resetPasswordSubmitPage.validation.invalidPassword') as string;
        } else if (error.code === "LimitExceededException") {
          this.message = this.$t('resetPasswordSubmitPage.validation.limitExceeded') as string;
        } else {
          this.message = `${this.$t('resetPasswordSubmitPage.validation.genericError')}: ${error.message}`;
        }
      }
    },
  },
});
